import useDevtools from '../hooks/useDevtools';
import AsyncDevtoolsPanel from './AsyncDevtoolsPanel';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DevtoolsLoader() {
  const devtools = useDevtools();
  if (!devtools || !devtools.isDevtoolsOpen) {
    return null;
  }
  return /*#__PURE__*/_jsx(AsyncDevtoolsPanel, {
    onClose: devtools.close
  });
}